var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardsList',{attrs:{"loading":_vm.loading,"type":"chef","items":_vm.chefs,"itemsPerPage":_vm.itemsPerPage},on:{"update-items-per-page":_vm.updateItemsPerPage}})}
var staticRenderFns = []

export { render, staticRenderFns }